import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import styled from "styled-components";
import { WHEN_LG, WHEN_MD, WHEN_XL } from "../constants";
import ContentContainer from "./ContentContainer";

const OuterContainer = styled(ContentContainer)`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;

  ${WHEN_MD} {
    flex-direction: row-reverse;
  }
`;

const InnerLeftContainer = styled.div`
  flex: 1;

  ${WHEN_MD} {
    padding-right: 2rem;
  }
`;
const InnerRightContainer = styled.div`
  flex: 1;
  ${WHEN_MD} {
    padding-left: 2rem;
    display: flex;
    justify-content: flex-end;
  }
`;

const HeadingContainer = styled.div`
  text-align: center;
  ${WHEN_MD} {
    padding-left: 2rem;
    text-align: left;
    padding-right: 5rem;
  }
`;
const Heading = styled.h1`
  margin: 0;
  margin-bottom: 0.5rem;
  ${WHEN_MD} {
    max-width: 200px;
  }
`;
const Subheading = styled.p`
  font-size: 20px;

  ${WHEN_LG} {
    font-size: 24px;
  }
`;

const BackgroundContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;

  width: 24.3vw;
  height: 35vw;

  ${WHEN_LG} {
    width: 28rem;
    height: 28rem;
  }
`;

export default function ProductShowcase4() {
  return (
    <OuterContainer>
      <BackgroundContainer className="hide-md-block">
        <StaticImage
          src="../images/product-showcase-4-bg.svg"
          alt="background"
          placeholder="blurred"
          objectFit="contain"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </BackgroundContainer>

      <InnerLeftContainer>
        <StaticImage
          src="../images/product-showcase-4.png"
          alt="accounts screenshot"
          placeholder="blurred"
          objectFit="contain"
          style={{ width: "100%", height: "100%", maxHeight: 350 }}
        />
      </InnerLeftContainer>
      <InnerRightContainer>
        <HeadingContainer>
          <Heading>Monthly Summaries</Heading>
          <StaticImage
            src="../images/product-showcase-4-stroke.svg"
            alt="stroke"
            placeholder="blurred"
            objectFit="contain"
            width={325}
            height={11}
          />
          <Subheading>Keep tabs on your cash flow</Subheading>
        </HeadingContainer>
      </InnerRightContainer>
    </OuterContainer>
  );
}
